import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddQuickLinkComponent } from './add-quick-link/add-quick-link.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [
    AddQuickLinkComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SidebarModalsModule { }
